import { Accordion, AccordionDetails, Typography } from '@mui/material';
import { memo, useState } from 'react';
import { PmiButton } from 'shell/components/shared/button';
import { ExpandMore } from '@mui/icons-material';
import CertificationTypeForm from './form';
import { AccordionSummary } from 'shell/components/shared/summary-accordion';

interface AccordionCertificateTypeProps {
  onBack: () => void;
}

const AccordionCertificateTypeComponent = ({
  onBack,
}: AccordionCertificateTypeProps): React.ReactElement => {
  const [open, setOpen] = useState<boolean>(true);
  return (
    <>
      <Accordion
        expanded={open}
        onChange={() => {
          setOpen(!open);
        }}
      >
        <AccordionSummary
          aria-controls={`panel-request-certificate`}
          id={`panel-request-certificate`}
          expandIcon={<ExpandMore />}
        >
          <Typography>Richiedi Certificato</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <CertificationTypeForm />
        </AccordionDetails>
      </Accordion>
      <div className="pmi-pt-3 pmi-d-flex pmi-justify-content-center">
        <div className="pmi-w-25 pmi-w-lg-15">
          <PmiButton variant="outlined" fullWidth color="secondary" onClick={onBack}>
            Indietro
          </PmiButton>
        </div>
        <div className="pmi-pl-2 pmi-w-25 pmi-w-lg-15">
          <PmiButton variant="outlined" fullWidth color="secondary" type="submit">
            Avanti
          </PmiButton>
        </div>
      </div>
    </>
  );
};

AccordionCertificateTypeComponent.displayName = 'Accordion Certificate Type';

const AccordionCertificateType = memo(AccordionCertificateTypeComponent);

export default AccordionCertificateType;
